export default __webpack_public_path__ + "static/person-game-2-f2ddd5e931ee3b42e2ebe39142f01e4b.png";